import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppDispatch } from 'store';
import { PublicAssetDetails } from 'store/studioSearch/types';
import { setPublicAssetImageDataAction } from '../slice';
import { PublicAssetImageData } from '../types';

const fetchAssetDetailsById =
  (assetSource: string, assetId: string, slug?: string) => async (dispatch: AppDispatch) => {
    const enpoint = slug
      ? `${endpoints.publicAssetV1Details}/${encodeURIComponent(slug)}`
      : `${endpoints.publicAssetV1Details}/${assetSource}/${assetId}`;
    const assetDetails = await apiRequest<PublicAssetDetails>(enpoint, {}, 'GET', 'data');
    const { artist, name, previewUrl, description } = assetDetails;
    const publicAssetImageData: PublicAssetImageData = {
      artistName: artist,
      designName: name,
      preview: previewUrl,
      description,
    };
    dispatch(setPublicAssetImageDataAction(publicAssetImageData));
  };

export default fetchAssetDetailsById;
